import React from "react";
import "./Testimonial.css";
import testimonialImage from "../../assets/TestimonialImage.jpg"; // Replace with your actual path
import Star from "@mui/icons-material/Star";
import { FaQuoteLeft} from "react-icons/fa";

const testimonials = [
  {
    name: "JANE SMITH",
    role: "FREELANCE CONSULTANT",
    review:
      "I was very impressed with Vedant Enterprises handling of my recent shipment. They went above and beyond to ensure my cargo arrived safely and on time. I will definitely be using their services again in the future.",
  },
  {
    name: "MICHAEL JOHNSON",
    role: "CEO",
    review:
      "I was very impressed with Vedant Enterprises handling of my recent shipment. They went above and beyond to ensure my cargo arrived safely and on time. I will definitely be using their services again in the future.",
  },
  {
    name: "SARAH LEE",
    role: "ONLINE RETAILER",
    review:
      "I was very impressed with Vedant Enterprises handling of my recent shipment. They went above and beyond to ensure my cargo arrived safely and on time. I will definitely be using their services again in the future.",
  },
  
];

const Testimonial = () => {
  return (
    <section className="testimonial-section">
      <div className="testimonial-left">
        <h2 className="testimonial-heading">TESTIMONIALS</h2>
        <h4 className="testimonial-subheading">OUR CLIENTS SPEAK FOR US</h4>
        <div className="image-container">
          <img src={testimonialImage} alt="Testimonial" />
          <div className="quote-icon">
            <FaQuoteLeft  className="icon"/>
          </div>
        </div>
        <div className="testimonial-card">
          <div className="stars">
            {[...Array(5)].map((_, i) => (
              <Star key={i} />
            ))}
          </div>
          <p className="client-review">
            I have been using Vedant Enterprises cargo logistic & transportation services
            for over a year now and I am extremely satisfied with their service.
            They are efficient, reliable, and always deliver on time. I highly
            recommend them to anyone in need of logistics services.
          </p>
          <p className="client-name">JOHN DOE, BUSINESS OWNER</p>
        </div>
      </div>
      <div className="testimonial-right">
        {testimonials.map((item, idx) => (
          <div key={idx} className="testimonial-card">
            <div className="stars">
              {[...Array(5)].map((_, i) => (
                <Star key={i} />
              ))}
            </div>
            <p className="client-review">{item.review}</p>
            <p className="client-name">
              {item.name},{item.role}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonial;
